import { Directive, ElementRef, inject, signal } from '@angular/core';

@Directive({
    selector: 'img',
    host: {
        '(error)': 'useFallbackImage()',
        '(load)': 'onLoad()',
        '[class.image-loaded]': 'imageLoaded()'
    },
    standalone: true
})
export class ImageDirective {
    private elRef = inject<ElementRef<HTMLImageElement>>(ElementRef);

    public imageLoaded = signal(false);

    useFallbackImage() {
        this.elRef.nativeElement.src = '/assets/download.png';
    }

    onLoad() {
        this.imageLoaded.set(true);
    }
}
